import { extend } from 'lodash';
import * as parseApiV2DoctorLocations from './parseApiV2DoctorLocation';

/**
 * @param {object} response
 * @param {Array<moment>} dates
 * @param {object} state
 */
export default function parseApiV2Response(response, dates, state) {
    const doctorLocations = {};

    if (response && response.data) {
        state.doctorLocationIds.forEach(doctorLocationId => {
            /**
             * AppointmentPicker uses fake time objects to communicate with the view.
             * Not saying that's the best way to do it, but that's the way it is.
             */

            const apiResponseDoctorLocation =
                tryGetProfessionalLocationFromApiResponse(response.data.professional_locations, doctorLocationId);

            if (response.data.show_government_insurance_notice) {
                extend(doctorLocations,
                    parseApiV2DoctorLocations.parseApiV2ShowGovernmentInsuranceNotice(doctorLocationId, dates));
            } else if (apiResponseDoctorLocation) {
                extend(doctorLocations,
                    parseApiV2DoctorLocations.parseApiV2DoctorLocation(apiResponseDoctorLocation, dates, state));
            } else {
                extend(doctorLocations,
                    parseApiV2DoctorLocations.parseApiV2EmptyDoctorLocation(doctorLocationId, dates));
            }
        });
    }

    return doctorLocations;
}

function tryGetProfessionalLocationFromApiResponse(professionalLocations, doctorLocationId) {
    let apiResponseDoctorLocation;

    if (professionalLocations) {
        apiResponseDoctorLocation = professionalLocations.find(
            x => areMatchingIds(doctorLocationId, x)
        );
    }

    return apiResponseDoctorLocation;
}

function areMatchingIds(doctorLocationId, profLoc) {
    const profLocId = `${profLoc.professional.professional_id}_${profLoc.location.location_id}`;
    const profLocIdWithAds = `${profLocId}_${profLoc.ad_served_event_id}`;
    const profLocIdWithSpo = `${profLocIdWithAds}_${profLoc.spo_ad_decision_id}`;


    return profLoc.professional &&
        profLoc.location &&
        ((profLocId === doctorLocationId && !profLoc.ad_served_event_id) ||
        (profLocIdWithAds === doctorLocationId && profLoc.ad_served_event_id) ||
        (profLocIdWithSpo === doctorLocationId && profLoc.ad_served_event_id && profLoc.spo_ad_decision_id));
}
